import { Coins } from '@terra-money/terra.js'
import BigNumber from 'bignumber.js'
import Numeral from 'numeral'

/**
 * Floor decimal number
 */
const _NumeralFormat = (num: string | BigNumber | number) => {
  return Numeral(num).format('0,0.[00]', (value) => Math.floor(value))
}
/**
 * toA is format number to auto K M B T after the number
 * @param num the number that want to format
 * @param fallBack the result if nothing
 */
export const toA = (num?: string | number | BigNumber, fallBack?: string) => {
  if (!num && num !== 0 && fallBack) return fallBack
  // the meaning of undefined is loading
  if (!num && num !== 0) return undefined
  // small number handler
  if (
    (typeof num === 'number' && num < 0.01) ||
    (typeof num === 'string' && parseFloat(num) < 0.01) ||
    (typeof num === 'object' && num.lt(0.01))
  ) {
    if (typeof num === 'object' && num.isNaN()) return '0'
    let _num = num
    if (typeof num === 'object') _num = num.toFixed(5)
    const res = Numeral(_num).format('0.[0000]a')
    return res === 'NaN' ? '0' : res
  }

  // custom handler
  const _num = new BigNumber(num)
  if (_num.gte(1e10)) {
    const a = _num.div(1e6)
    const b = _NumeralFormat(a)
    return b + 'M'
  } else if (_num.gte(1e6)) {
    const a = _num.div(1e3)
    const b = _NumeralFormat(a)
    return b + 'K'
  }
  // default return
  return _NumeralFormat(num)
}

export const shortenAddress = (
  address?: string,
  len = 4,
  only: 'front' | 'end' | 'both' = 'both',
) => {
  if (only === 'front') return address ? `${address.slice(0, len)}...` : ''
  if (only === 'end') return address ? `...${address.slice(-len)}` : ''
  return address ? `${address.slice(0, len)}...${address.slice(-len)}` : ''
}

export const coinsToTxFee = (coins?: Coins): string => {
  const _coins = coins?.toArray()
  return (
    _coins
      ?.map((coin) => {
        const amount = new BigNumber(coin.amount.toString()).div('1e6')
        return `${toA(amount)} ${coin.denom
          .slice(1)
          .replace('usd', 'ust')
          .toUpperCase()}`
      })
      .join(', ') || ''
  )
}
